export default {
      id: "sbp-btn-white-usage",
      viewBox: "0 0 60 32",
      url: __webpack_public_path__ + "svgsprite.svg#sbp-btn-white",
      toString: function () {
        return this.url;
      }
    }